<template>
    <PageLayout>
        <!-- <Header /> -->
        <!-- <GlobalNavigationBar /> -->
        <slot name="gnb"> </slot>
        <!---------- 시작 : OuterWrap ---------->
        <div id="outer-wrap">
            <slot name="customLeft" v-if="useCustomLeft"></slot>
            <LeftMenu v-if="useLeft" />
            <SubContentTemplate :isFull="!useLeft" :viewtype="viewtype">
                <template v-slot:body>
                    <slot></slot>
                </template>
            </SubContentTemplate>
            <slot name="customRight" v-if="useCustomRight"></slot>
        </div>
        <!---------- 끝 : wrapper ---------->
    </PageLayout>
</template>

<script>
import { PageLayout } from "@appbase/templates";
import { LeftMenu } from "../components/common";
import SubContentTemplate from "./SubContentTemplate.vue";
export default {
    components: { PageLayout, LeftMenu, SubContentTemplate },
    props: {
        useLeft: { type: Boolean, default: true },
        useCustomLeft: { type: Boolean, default: false },
        useCustomRight: { type: Boolean, default: false },
        viewtype: { type: Number, default: 0 },
    },
};
</script>

<style></style>
